"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

function e(e) {
  return e && "object" == typeof e && "default" in e ? e["default"] : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = e(require("@babel/runtime/helpers/classCallCheck")),
    r = e(require("@babel/runtime/helpers/createClass")),
    n = e(require("@babel/runtime/helpers/possibleConstructorReturn")),
    a = e(require("@babel/runtime/helpers/getPrototypeOf")),
    i = e(require("@babel/runtime/helpers/inherits")),
    s = e(require("@babel/runtime/helpers/slicedToArray")),
    o = e(require("@babel/runtime/helpers/objectWithoutProperties")),
    u = e(require("@babel/runtime/helpers/objectSpread2")),
    l = require("messageformat-parser"),
    c = e(require("make-plural/umd/plurals")),
    f = function f(e) {
  return "string" == typeof e;
},
    h = function h(e) {
  return "function" == typeof e;
};

function v(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = new Intl.DateTimeFormat(e, t);
  return function (e) {
    return f(e) && (e = new Date(e)), r.format(e);
  };
}

function m(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = new Intl.NumberFormat(e, t);
  return function (e) {
    return r.format(e);
  };
}

var g = Object.freeze({
  date: v,
  number: m
}),
    p = function p(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
    plurals: void 0
  },
      n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
  t = t || e;

  var a = r.plurals,
      i = function i(e) {
    return f(e) ? n[e] || {
      style: e
    } : e;
  },
      s = function s(e, r) {
    return function (n) {
      var a = h(r) ? r(n) : r,
          i = Array.isArray(a) ? a : [a],
          s = new Intl.NumberFormat(t),
          o = s.format(e);
      return i.map(function (e) {
        return f(e) ? e.replace("#", o) : e;
      });
    };
  };

  return {
    plural: function plural(e, t) {
      var r = t.offset,
          n = void 0 === r ? 0 : r,
          i = o(t, ["offset"]),
          u = i[e] || i[a(e - n)];
      return s(e - n, u);
    },
    selectordinal: function selectordinal(e, t) {
      var r = t.offset,
          n = void 0 === r ? 0 : r,
          i = o(t, ["offset"]),
          u = i[e] || i[a(e - n, !0)];
      return s(e - n, u);
    },
    select: function select(e, t) {
      return t[e] || t.other;
    },
    number: function number(e, r) {
      return m(t, i(r))(e);
    },
    date: function date(e, r) {
      return v(t, i(r))(e);
    },
    undefined: function undefined(e) {
      return e;
    }
  };
};

function y(e) {
  var t = e.locale,
      r = e.locales,
      n = e.values,
      a = e.formats,
      i = e.localeData,
      s = p(t, r, i, a);
  return function e(t, r, a) {
    var i = n[t],
        o = s[r](i, a),
        u = h(o) ? o(e) : o;
    return Array.isArray(u) ? u.join("") : u;
  };
}

function d(e, t, r, n) {
  return function (a) {
    var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        o = y({
      locale: t,
      locales: r,
      localeData: n,
      formats: i,
      values: a
    }),
        u = function e(t) {
      return Array.isArray(t) ? t.reduce(function (t, r) {
        if (f(r)) return t + r;
        var n = s(r, 3),
            a = n[0],
            i = n[1],
            u = n[2],
            l = {};
        null == u || f(u) ? l = u : Object.keys(u).forEach(function (t) {
          l[t] = e(u[t]);
        });
        var c = o(a, i, l);
        return null == c ? t : t + c;
      }, "") : t;
    },
        l = u(e);

    return l.trim();
  };
}

var b = Object.freeze({
  compile: function compile(e) {
    try {
      return function e(t) {
        return t.filter(function (e) {
          return !f(e);
        }).length ? t.map(function (t) {
          if (f(t)) return t;
          if ("octothorpe" === t.type) return "#";
          if ("argument" === t.type) return [t.arg];
          if ("function" === t.type) return [t.arg, t.key, t.params[0]];
          var r = t.offset ? parseInt(t.offset) : void 0,
              n = {};
          return t.cases.forEach(function (t) {
            n[t.key] = e(t.tokens);
          }), [t.arg, t.type, u({
            offset: r
          }, n)];
        }) : t.join("");
      }(l.parse(e));
    } catch (t) {
      return console.error("Message cannot be parsed due to syntax erorrs: ".concat(e)), e;
    }
  },
  loadLocaleData: function loadLocaleData(e) {
    if (e) {
      var t = e.split(/[_-]/),
          r = s(t, 1),
          n = r[0];
      return {
        plurals: c[n]
      };
    }
  }
}),
    _ = function () {
  function e() {
    t(this, e), this._events = {};
  }

  return r(e, [{
    key: "on",
    value: function value(e, t) {
      var r = this;
      return this._hasEvent(e) || (this._events[e] = []), this._events[e].push(t), function () {
        return r.removeListener(e, t);
      };
    }
  }, {
    key: "removeListener",
    value: function value(e, t) {
      if (this._hasEvent(e)) {
        var r = this._events[e].indexOf(t);

        ~r && this._events[e].splice(r, 1);
      }
    }
  }, {
    key: "emit",
    value: function value(e) {
      for (var t = this, r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) {
        n[a - 1] = arguments[a];
      }

      return this._hasEvent(e) ? Promise.all(this._events[e].map(function (e) {
        return e.apply(t, n);
      }).map(function (e) {
        return null == e || null == e.then ? Promise.resolve(e) : e;
      })) : Promise.resolve();
    }
  }, {
    key: "_hasEvent",
    value: function value(e) {
      return Array.isArray(this._events[e]);
    }
  }]), e;
}(),
    k = function (e) {
  function s(e) {
    var r;
    return t(this, s), r = n(this, a(s).call(this)), r._catalogs = {}, null != e.catalogs && r._loadAll(e.catalogs), null == e.locale && null == e.locales || r._activate(e.locale, e.locales), r;
  }

  return i(s, e), r(s, [{
    key: "_loadAll",
    value: function value(e) {
      var t = this;
      Object.keys(e).map(function (r) {
        return t._load(r, e[r]);
      });
    }
  }, {
    key: "loadAll",
    value: function value(e) {
      var t = this;
      return Object.keys(e).map(function (r) {
        return t.load(r, e[r]);
      });
    }
  }, {
    key: "_load",
    value: function value(e, t) {
      if (null != t) if (null == this._catalogs[e]) this._catalogs[e] = t;else {
        var r = this._catalogs[e];
        Object.assign(r.messages, t.messages), Object.assign(r.localeData, t.localeData);
      }
    }
  }, {
    key: "load",
    value: function value(e, t) {
      var r = this;
      return this.emit("load", e, t).then(function () {
        return r._load(e, t), r.emit("change");
      });
    }
  }, {
    key: "_activate",
    value: function value(e, t) {
      this._locale = e, this._locales = t;
    }
  }, {
    key: "activate",
    value: function value(e, t) {
      var r = this;
      return this.emit("activate", e).then(function () {
        return r._activate(e, t), r.emit("change");
      });
    }
  }, {
    key: "_",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          n = r.message,
          a = r.formats;
      f(e) || (t = e.values || t, n = e.message, e = e.id);
      var i = this.messages[e] || n || e,
          s = this._missing;
      return s && !this.messages[e] ? h(s) ? s(this.locale, e) : s : f(i) ? i : d(i, this.locale, this.locales, this.localeData)(t, a);
    }
  }, {
    key: "date",
    value: function value(e, t) {
      return v(this.locales || this.locale, t)(e);
    }
  }, {
    key: "number",
    value: function value(e, t) {
      return m(this.locales || this.locale, t)(e);
    }
  }, {
    key: "locale",
    get: function get() {
      return this._locale;
    }
  }, {
    key: "locales",
    get: function get() {
      return this._locales;
    }
  }, {
    key: "catalog",
    get: function get() {
      return this._catalogs[this.locale];
    }
  }, {
    key: "messages",
    get: function get() {
      return this.catalog && this.catalog.messages ? this.catalog.messages : {};
    }
  }, {
    key: "localeData",
    get: function get() {
      return this.catalog.localeData;
    }
  }]), s;
}(_);

function j() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      t = new k(e);
  return t.messageFormat = b, e.missing && (t._missing = e.missing), t;
}

var A = j();
exports.I18n = k, exports.formats = g, exports.i18n = A, exports.setupI18n = j;